import { slicedToArray as _slicedToArray, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.esm.js';
import { PliableImage } from '@costar-ui/components';
import React from 'react';
import { ContentCarousel } from './content-carousel.esm.js';

function PlacardImageCarousel(props) {
  var images = props.images,
    id = props.id,
    enableCaption = props.enableCaption,
    percentAspectRatio = props.percentAspectRatio;
  //active images index (0-based)
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    active = _React$useState2[0],
    setActive = _React$useState2[1];
  var renderContentFor = React.useCallback(function (index) {
    return /*#__PURE__*/React.createElement(PliableImage, _extends({
      className: "size-full object-cover",
      enableCaption: enableCaption
    }, images[index]));
  }, [enableCaption, images]);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "carousel-pane",
    className: "relative"
  }, /*#__PURE__*/React.createElement(ContentCarousel, {
    totalCount: images.length,
    renderContentFor: renderContentFor,
    key: id,
    active: active,
    setActive: setActive,
    hovered: true,
    enableCaption: enableCaption,
    percentAspectRatio: percentAspectRatio
  }));
}

export { PlacardImageCarousel };
//# sourceMappingURL=placard-image-carousel.esm.js.map
